exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".promo-flash-banner .annual-sales.extra-small {\n  justify-content: flex-end;\n}", ""]);

// exports
